/*
 * @Author: chenhui@didichuxing.com 
 * @Date: 2019-01-31
 * @Description:  兑换码兑换结果页
 */
<template>
  <div class="xtc-container">
    <div class="xtc-container-main">
      <!-- banner start -->
      <div class="banner">
        <template v-if="(this.configInfo) && !allFalse">
          <rich-slide ref="slide" :data="focusImg">
            <rich-slide-item v-for="(item, index) in focusImg" :key="index" @click.native="clickHandler(item, index)">
              <div class="slide-item">
                <span class="mainTitle">{{item.title}}</span>
                <span class="subTitle">{{item.subTitle}}</span>
                <img v-lazy="lazyImgObj(item.url)">
              </div>
            </rich-slide-item>
          </rich-slide>
        </template>
        <!-- 接口拉取失败 -->
        <template v-if="beforeHasPoi || allFalse">
          <div class="errStatus" :style="{'background-image': bannerBg}"></div>
        </template>
      </div>
      <!-- banner end -->

      <div class="code-box" v-if="configInfo && couponData">
        <!-- 领取成功后券列表 -->
        <div class="line-info">
        <div class="line-wrap-bk"><span class="couponSuccess"></span><strong>{{gettext('领取成功')}}</strong></div>
        <rich-button 
        class="copy-btn btnFixed"
        @click="goToUse"
        >
        {{configInfo.btnText}}
        </rich-button>
        </div>
        <scroll-coupon-list
        v-if="this.couponData"
        class="coupon-list"
        :couponData="couponData"
        :couponCurrency="this.currency">
        </scroll-coupon-list>
      </div>

      <!-- 接口拉取失败 -->
      <div class="code-box" v-if="allFalse">
        <div class="line-info">
          <div class="line-wrap-bk"><strong>{{gettext('恭喜你！兑换成功！')}}</strong></div>
        </div>
        <rich-button 
          class="copy-btn btnFixed"
          @click="goToUse"
        >
          {{gettext('返回首页')}}
        </rich-button>
      </div>      
    </div>
    <loading-mask v-show="loading"></loading-mask>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import trackEvent from '@/common/js/track'
import { setTitle } from '@/common/js/bridge'
import ScrollCouponList from './modules/scroll-coupon-list'
import { util } from '@didi/soda-common'
import { debounce, getScheme } from '@/common/js/utils'
import getCountryConfig from '@/common/config/country-config'
import LoadingMask from '@/components/loading/loading-mask'
const { env } = util

export default {
  name: 'promoResult',
  data () {
    return {
      poiLat: 0,
      poiLng: 0,
      focusImg: [],
      redeemValue: '',
      configInfo: null,
      couponData: {
        couponList: {}
      },
      couponError: '',
      couponFalse: false,
      redeemStatus: false,
      allFalse: false,
      actStatus: 0,
      currency: '',
      loading: true,
      beforeHasPoi: true
    }
  },
  components: {
    ScrollCouponList,
    LoadingMask
  },
  computed: {
    ...mapGetters({
      globalParams: 'globalParams',
      promoResult: 'promoResult'
    }),
    country () {
      return this.$store.state.country
    },
    // 根据不同国家展示不同优惠券背景占位图
    bannerBg () {
      return `url(${getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['C_BANNER_BG']})`
    }
  },
  methods: {
    ...mapActions({
      getGlobalInfo: 'getGlobalInfo',
      getPromoResult: 'getPromoResult'
    }),
    // 图片懒加载配置
    lazyImgObj (value) {
      return {
        src: value,
        error: `${getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['C_BANNER_BG']}`,
        loading: `${getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['C_BANNER_BG']}`
      }
    },
    toApp () {},
    goToUse: debounce(function () {
      // 调用bridge，嵌入端ontravel跳转，独立端scheme协议跳转至外卖首页
      location.href = `${getScheme()}://soda/homePage?closeSideMenu=1`
    }),
    async fetchPromoResult (data) {
      const locationInfo = await SodaBridge('getLocationInfo', {}) || {}
      let params = {
        rid: this.params.rid || 0,
        enterTime: new Date().getTime(),
        ua: navigator.userAgent,
        token: data.token,
        poiCityId: locationInfo.data.city_id
      }
      if (env.inSoda) {
        params.channelNo = 2
      } else if (env.inDidiApp) {
        params.channelNo = 1
      }
      let res = await this.getPromoResult(params)

      if (res && (res.errno === 0) && res.data) {
        this.loading = false
        // this.loadingToast.hide()
        this.configInfo = res.data.pageConfig.sharePage.resultPage
        this.focusImg = this.configInfo.focusImg.list
        this.couponData = {'couponList': res.data.couponList}
        this.currency = res.data.pageConfig.sharePage.rewardInfo.currency
        if (this.configInfo.title) {
          setTitle(this.configInfo.title)
        }
        // trackEvent({
        //   eventId: 'sailing_c_x_invitereceive_common_sw',
        //   eventLabel: '推荐有奖领取页面展示',
        //   attrs: {
        //     invite_code: this.params.code || '',
        //     channel_id: this.params.channel_id || '',
        //     activity_id: this.params.activityId || '',
        //     page_type: this.configInfo.sharePage.type || '',
        //     status: 1
        //   }
        // })
      } else {
        this.allFalse = true
        // this.loadingToast.hide()
        this.loading = false
        this.couponFalse = true
        this.couponError = res.errmsg
        // trackEvent({
        //   eventId: 'sailing_c_x_invitereceive_common_sw',
        //   eventLabel: '推荐有奖领取页面展示',
        //   attrs: {
        //     invite_code: this.params.code || '',
        //     channel_id: this.params.channel_id || '',
        //     activity_id: this.params.activityId || '',
        //     page_type: '',
        //     status: 3
        //   }
        // })
      }
    }
  },
  created () {
    setTitle(this.gettext('推荐有奖'))
    // this.loadingToast = this.$createToast({
    //   mask: true,
    //   txt: this.gettext('正在加载...')
    // })
    // this.loadingToast.show()
    this.getGlobalInfo()
      .then((data) => this.fetchPromoResult(data))
      .catch(err => {
        console.log(err)
        this.loading = false
      })
    // trackEvent({
    //   eventId: 'sailing_c_x_invitereceive_common_sw',
    //   eventLabel: '推荐有奖领取页面展示',
    //   attrs: {
    //     invite_code: this.params.code || '',
    //     channel_id: this.params.channel_id || '',
    //     activity_id: this.params.activityId || '',
    //     page_type: '',
    //     status: 2
    //   }
    // })
    // this.redeemValue = this.params.code || ''
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var";
.xtc-container {
  position: relative;
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .rich-dialog-title {
    .rich-dialog-title-def {
      font-size: 32px;
      color: #333;
    }
  }
  .btnFixed {
    width: 90%;
    padding: 0;
    position: fixed;
    left: 0;
    bottom: 36px;
    z-index: 1;
  }
  &-main {
    margin: 0 0 104px 0;
    .btnBd {
      padding: 36px 0;
      background: #fff;
    }
    .rich-btn {
      padding: 0;
      margin: 40px 36px 0;
      height: 92px;
      line-height: 92px;
      z-index: 99;
      &:active:after{
        border: none;
      }
    }     
    .slide-item {
      position: relative;
      .mainTitle {
        display: none;
        position: absolute;
        left: 10px;
        bottom: 50px;
      }
      .subTitle {
        display: none;
        position: absolute;
        left: 10px;
        bottom: 10px;
        font-size: 28px;
      }
      img {
        width: 100%;
        height: 430px;
      }
    } 
    .banner {
      overflow: hidden;
      width: 100%;
      height: 430px;
      .errStatus {
        overflow: hidden;
        width: 100%;
        height: 430px;
        background-size: 100% 430px;
        text-align: center;
        strong{
          margin: 200px auto 0;
          display: block;
          font-weight: normal;
        }
      }
    }
    .detail-rules {
      color: #4A4A4A;
      font-size: 32px;
      margin-top: 37px;
      text-align: center;
      .richic-arrow {
        color:#999999;
        font-size: 24px;
        margin-left: 6px;
      }
    }
    // .rich-input:after {
    //   border: none;
    // }   
    .code-box {
      margin: 54px 36px 0;
      text-align: center;
      .headImg {
        border: 0;
        background: url("~@/assets/images/xtc/headimg@2x.png") no-repeat;
        background-size: 160px 160px;
        max-width: none;
        object-fit: cover;
        border-radius: 160px;
      }
      .redeem {
        .rich-btn {
          margin: 0;
        }
        margin-top: 60px;
        // .rich-input {
        //   height: 90px;
        //   padding: 12px;
        //   margin-bottom: 60px;
        //   border-bottom: 1px rgba(0,0,0,0.10) solid;
        //   font-family: 'Aspira-Demi';
        //   font-size: 48px;
        //   font-weight: bold;
        // }
      }
      // .rich-input-field {
      //   font-size: 48px;
      // }
      .line-info {
        img {
          width: 100px;
          height: 100px;
          overflow: hidden;
          display: block;
          margin: 54px auto 20px;
        }
        .line-wrap-bk {
          margin: 0 95px 60px;
          line-height: 38px;
          font-size: 32px;
          text-align: center;
          strong {
            display: block;
            margin: 20px auto;
            font-weight: normal;
          }
          .couponError {
            display: block;
            margin: 0 auto;
            width: 100px;
            height: 100px;
            @include coupon-get-error();
            background-size: 100px 100px;
          }
          .couponSuccess {
            display: block;
            margin: 0 auto;
            width: 100px;
            height: 100px;
            @include coupon-get-success();
            background-size: 100px 100px;
          }
        }
      }
      .line-wrap {
        display: flex;
        justify-content: center;
        .line {
          display: block;
          width: 146px;
          height: 2px;
          margin-top: 14px;
          &.r  {
            background: linear-gradient(to right, #D8D8D8 , #ffffff);
            margin-left: 24px;
          }
          &.l {
            background: linear-gradient(to right, #ffffff, #D8D8D8);
            margin-right: 24px;
          }
        }
        .text {
          color: #999999;
          display: block;
          font-size: 28px;
          margin-bottom: 48px;
        }
      }
      .copy-wrap {
        display: flex;
        justify-content: center;
        .copy-btn {
          display: inline-block;
          width: 40px;
          height: 40px;
          @include copy-icon();
          margin-left: 17px;
          margin-top: 20px;
          box-sizing: border-box;
        }
        .code {
          font-size: 48px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 33px;
          font-weight: bold;
          -webkit-user-select: text;
        }
      }
      
    }
    .share-box {
      margin-top: 55px;
      .title {
        font-size: 28px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 39px;
      }
    }
  }
  &-footer {
    box-sizing: border-box;
    height: 244px;
    width: 100%;
    background: #F7F8FA;
    padding: 39px 0;
  }
}
</style>
 